// Meta (Facebook) Pixel integration
export const META_PIXEL_ID = '1287603379450199'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

let initialized = false

// The Meta Pixel loads an external cross-origin script (fbevents.js). Inside
// sandboxed preview iframes / editors that request is frequently blocked and
// the browser surfaces it as an opaque "Script error.". We only initialize on
// a real published domain so the editor preview stays clean.
function isLivePublishedSite(): boolean {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  if (!host) return false
  // Skip local dev and Magic Patterns editor/preview hosts.
  const blocked = [
    'localhost',
    '127.0.0.1',
    'magicpatterns.com',
    'magicpatterns.app',
  ]
  if (blocked.some((b) => host === b || host.endsWith(`.${b}`))) return false
  // Skip when running inside an iframe (editor preview).
  try {
    if (window.self !== window.top) return false
  } catch {
    // Cross-origin framing throws — treat as preview, skip.
    return false
  }
  return true
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  if (!isLivePublishedSite()) return
  initialized = true

  try {
    /* eslint-disable */
    ;(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      t.onerror = function () {
        /* fail silently if blocked */
      }
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq?.('init', META_PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch {
    /* never let pixel setup break the app */
  }
}

export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', event, params)
  } catch {
    /* no-op */
  }
}
